import React from 'react';
import TinyEditor from 'components/Dashboard/Influence/CrmEmails/TinyEditor/TinyEditor';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import { EmailBodySkeleton } from './CrmEmailComponentSkeleton';
import { LoadingSummaryText } from 'components/Dashboard/UserContent/ui/CreatingSummaryLoading';
import FromToFields from 'components/Dashboard/Influence/CrmEmails/CrmEmailComponent/FromToFields';
import SubjectElement from 'components/Dashboard/Influence/CrmEmails/CrmEmailComponent/SubjectElement';

function EmailComponentBody({
  currentEmailDetails,
  disabledCondition,
  disabledToCondition,
  handleSubject,
  handleBody,
  initialToValue,
  emailAddresses,
  handleFrom,
  autofocusFieldFromUrl,
  setEditorOnLoad,
  setActiveTab,
  setActiveRecipientsOption,
  skeletonCondition,
  isLoadingWritingAssistant,
  showSendPreviewPopUp,
  refreshEmailData,
  emailState,
  setEmailState,
}) {
  const isMobile = useIsMobile(768);
  const autofocusField = () => {
    if (!showSendPreviewPopUp) {
      if (!currentEmailDetails?.subject.length) {
        return 'subject';
      } else if (!currentEmailDetails?.sendRecords?.length || autofocusFieldFromUrl?.current === 'to') {
        return 'to';
      } else {
        return 'body';
      }
    }
  };

  const { senderEmailAddressId, mailMergeFields } = currentEmailDetails;
  return (
    <div className='h-100 email-component-body'>
      {isLoadingWritingAssistant ? (
        <div className='email-component-container flex-grow-1 position-relative d-flex align-items-center justify-content-center'>
          <LoadingSummaryText />
        </div>
      ) : (
        <div
          className={`email-component-container flex-grow-1 position-relative ${
            currentEmailDetails.status === 'Sent' ? 'email-component-container-sent' : ''
          }`}
          style={skeletonCondition ? { border: 'none' } : null}
        >
          {skeletonCondition && <EmailBodySkeleton />}
          <div
            className='h-100 d-flex flex-column'
            style={{
              opacity: skeletonCondition ? 0 : 1,
              position: skeletonCondition ? 'fixed' : undefined,
            }}
          >
            {isMobile && (
              <FromToFields
                disabledCondition={disabledCondition}
                emailAddresses={emailAddresses}
                currentEmailDetails={currentEmailDetails}
                handleFrom={handleFrom}
                disabledToCondition={disabledToCondition}
                initialToValue={initialToValue}
                autofocusField={autofocusField}
                isMobile={isMobile}
                setActiveTab={setActiveTab}
                setActiveRecipientsOption={setActiveRecipientsOption}
                refreshEmailData={refreshEmailData}
              />
            )}
            <div className='email-component-section email-subject-section'>
              <div>
                <SubjectElement
                  value={currentEmailDetails.subject}
                  disabled={disabledCondition}
                  autoFocus={autofocusField() === 'subject'}
                  onChange={handleSubject}
                  mailMergeFields={mailMergeFields}
                />
              </div>
            </div>
            <TinyEditor
              stateContent={currentEmailDetails.body}
              handleBody={handleBody}
              disabled={disabledCondition}
              autoFocus={autofocusField() === 'body'}
              setEditorOnLoad={setEditorOnLoad}
              emailState={emailState}
              setEmailState={setEmailState}
              key={senderEmailAddressId + mailMergeFields?.join(',')}
            />
          </div>
        </div>
      )}

      {!isMobile && (
        <>
          <FromToFields
            disabledCondition={disabledCondition}
            emailAddresses={emailAddresses}
            currentEmailDetails={currentEmailDetails}
            handleFrom={handleFrom}
            disabledToCondition={disabledToCondition}
            initialToValue={initialToValue}
            autofocusField={autofocusField}
            setActiveTab={setActiveTab}
            setActiveRecipientsOption={setActiveRecipientsOption}
            refreshEmailData={refreshEmailData}
          />
        </>
      )}
    </div>
  );
}

export default EmailComponentBody;
